<template>
	<div class="stepper">
		<div v-for="(step, index) in steps" :key="index" class="step">
			<div class="step-index" :class="{'completed': index + 1 <= currentStep}">
				{{ index + 1 }}
			</div>
			<div class="step-label" :class="{'completed': index + 1 <= currentStep}">
				{{ step.label }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Stepper',
	props: ['steps', 'currentStep'],
};
</script>

<style lang="scss" scoped>
.stepper {
	display: inline-block;
	position: relative;
	user-select: none;
	&:after {
		content: '';
		border-top: 1px solid var(--app-color-primary);
		position: absolute;
		width: 90%;
		top: 20px;
		left: 20px;
	}
	.step:last-child {
		margin-right: 0px;
	}
	.step {
		display: inline-flex;
		flex-direction: column;
		align-items: center;
		margin-right: 80px;
		position: relative;
		z-index: 1;
		.step-index {
			display: inline-flex;
			width: 40px;
			height: 40px;
			border: 1px solid var(--app-color-primary);
			border-radius: 50%;
			justify-content: center;
			align-items: center;
			font-size: 20px;
			color: var(--app-color-primary);
			background-color: white;
			margin-bottom: 10px;
			&.completed {
				background-color: var(--app-color-primary);
				color: white;
			}
		}
		.step-label {
			width: 60px;
			text-align: center;
			color: var(--app-color-primary);
			font-size: 12px;
			line-height: 14px;
			&.completed {
				font-weight: bold;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/ui/stepper/Stepper.vue